module.exports = __webpack_public_path__ + "static/media/experiment.7828b845.webp";